import { lazy } from 'react'

export const MediaLibrary = lazy(() => import('./pages/media-library'))
